module.exports = __webpack_public_path__ + "media/images/emblems/Konolfingen_(district)-coat_of_arms-2ed53101886ed2346ad9889d7af5e3c1.svg";